import React, { PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export interface ItemInterface extends PropsWithChildren {
  id: number;
  grip?: boolean;
}

export function Item<T extends ItemInterface>(props: T) {
  const { grip = true } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (grip) {
    return (
      <div style={style} className="sortable-list-item">
        <i
          ref={ setNodeRef }
          {...attributes}
          {...listeners}
          className="fas fa-grip-lines sortable-list-item-grip"></i>
        {props.children}
      </div>
    );
  } else {
    return (
      <div ref={ setNodeRef } style={style} {...attributes} {...listeners} className="sortable-list-item">
        {props.children}
      </div>
    );
  }
}
